<template>
    <textarea :value="value" @input="$emit('input', $event.target.value)" :placeholder="placeholder" :rows="rows"
        :class="[
            'tw:w-full tw:px-4 tw:py-3 tw:text-sm tw:text-slate-700 tw:bg-white tw:border tw:border-slate-300 tw:rounded-xl tw:shadow-sm',
            'tw:focus:outline-none tw:focus:ring-2 tw:focus:ring-primary/20 tw:focus:border-primary',
            'tw:transition-all tw:resize-y',
            customClass
        ]">
    </textarea>
</template>

<script>
export default {
    name: 'BaseTextArea',
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        rows: {
            type: [Number, String],
            default: 3
        },
        customClass: {
            type: String,
            default: ''
        }
    }
}
</script>